import HeaderSection from 'components/GlobalModals/ProductSamplesModal/HeaderSection/HeaderSection';

export default HeaderSection;
